import React, { useContext, useEffect, useState } from 'react';
import { LiveContext } from 'src/context/LiveContext';
import { Dialog } from 'components/Atoms/Dialog/Dialog';
import { VisuallyHidden } from 'components/Atoms/VisuallyHidden/VisuallyHidden';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';
import { PageContext } from 'src/context/PageContext';
import classNames from 'classnames';
import styles from './LiveHeader.module.scss';

export function LiveJoinInfo() {
  const { joinCode, shortUrl } = useContext(LiveContext);
  const { urlParams } = useContext(PageContext);
  const [url, setUrl] = useState('');
  useEffect(() => {
    setUrl(
      `${window?.location?.origin}/${urlParams?.organization}/${urlParams?.locale}/live/${
        urlParams?.uuid
      }/${encodeURIComponent(urlParams?.sessionId || '')}/${
        urlParams?.preview ? 'preview' : encodeURIComponent(urlParams?.version || '')
      }`,
    );
  }, [
    urlParams?.locale,
    urlParams?.organization,
    urlParams?.preview,
    urlParams?.sessionId,
    urlParams?.uuid,
    urlParams?.version,
  ]);
  const { t } = useTranslation();
  const { showJoinDetails } = useContext(LiveContext);

  return (
    <Dialog
      open={!!showJoinDetails}
      title={<VisuallyHidden>{t('liveAdmin.joinAt')}</VisuallyHidden>}
      classname={classNames(styles.liveJoinInfoDialog, styles.liveJoinInfoText)}
      content={
        <div className={styles.liveJoinInfoContainer}>
          <div className={styles.liveJoinInfoLeftSide}>
            {t('liveAdmin.joinAt')}
            <br className={styles.lineBreak} />{' '}
            <div className={classNames(styles.liveJoinShortUrl, styles.liveJoinInfoCodeText)}>
              <strong>{shortUrl}</strong>
            </div>
            <hr className={styles.liveJoinDivider} />
            {t('liveAdmin.useCode')}
            <br className={styles.lineBreak} />{' '}
            <div className={classNames(styles.liveJoinCode, styles.liveJoinInfoCodeText)}>
              <strong>{joinCode}</strong>
            </div>
            <br className={styles.lineBreak} />
          </div>
          {url && (
            <div className={styles.liveJoinInfoQrContnainer}>
              <QRCode value={url} size={525} />
            </div>
          )}
        </div>
      }
    />
  );
}
